import React, { useState, useEffect } from 'react';
import { Card, Select, Table, Tag, Typography, message } from 'antd';
import dayjs from 'dayjs';
import api from '../../api/axios';
import { getBranches } from '../../api/branches';
import useAuthStore from '../../store/authStore';
import { dateSorter, textSorter } from '../../utils/tableSorters';

const { Text } = Typography;

const DAYS_OPTIONS = [
  { value: 7, label: 'Son 7 gün' },
  { value: 30, label: 'Son 30 gün' },
  { value: 90, label: 'Son 90 gün' },
  { value: 365, label: 'Son 1 yıl' },
];

const columns = [
  // Liste tamami bellekte - istemci siralayicilari dogru calisir.
  { title: 'Tarih', dataIndex: 'date', width: 130, sorter: dateSorter('date'), render: (v) => dayjs(v).format('DD.MM.YYYY ddd') },
  { title: 'Saat', dataIndex: 'start_time', width: 70, sorter: textSorter('start_time') },
  { title: 'Derslik', dataIndex: 'classroom', sorter: textSorter('classroom') },
  {
    title: 'Proje Girilmemiş Öğrenciler',
    dataIndex: 'students',
    // Ogrenci SAYISINA gore siralanir - hangi derste daha cok eksik var?
    sorter: (a, b) => (a.students?.length || 0) - (b.students?.length || 0),
    render: (students) => (
      <div className="flex flex-wrap gap-1">
        {(students || []).map((s, i) => (
          <Tag key={i} color="orange" style={{ margin: 0 }}>{s}</Tag>
        ))}
      </div>
    ),
  },
];

const MissingProjectsReportTab = () => {
  const { user } = useAuthStore();
  const isBranchManager = user?.role === 'branch_manager';

  const [days, setDays] = useState(30);
  const [branchId, setBranchId] = useState(isBranchManager ? user?.branch_id : null);
  const [branches, setBranches] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isBranchManager) {
      getBranches({ per_page: 100 }).then(res => setBranches(res.data.data || [])).catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { fetchRows(); }, [days, branchId]);

  const fetchRows = async () => {
    setLoading(true);
    try {
      const res = await api.get('/reports/missing-projects', {
        params: { days, branch_id: branchId || undefined },
      });
      setRows(res.data || []);
    } catch {
      message.error('Veriler yüklenemedi.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="flex gap-3 mb-4 flex-wrap items-center">
        <Select
          value={days}
          onChange={setDays}
          style={{ width: 160 }}
          options={DAYS_OPTIONS}
        />
        {!isBranchManager && (
          <Select
            placeholder="Tüm şubeler"
            allowClear
            style={{ width: 200 }}
            value={branchId}
            onChange={v => setBranchId(v ?? null)}
            options={branches.map(b => ({ value: b.id, label: b.name }))}
          />
        )}
        <Text type="secondary" className="text-sm">
          {!loading && (rows.length > 0 ? `${rows.length} ders` : 'Bu aralıkta eksik proje yok')}
        </Text>
      </div>

      <Card>
        <Table
          dataSource={rows}
          columns={columns}
          rowKey={(r) => r.date + r.classroom + r.start_time}
          loading={loading}
          size="small"
          pagination={{
            // `pageSize` DEĞİL `defaultPageSize`: pageSize vermek alanı
            // KONTROLLÜ yapıyor ve kullanıcı 100 seçse bile prop onu her
            // render'da 20'ye geri zorluyordu — sayfa boyutu seçicisi
            // görünüyor ama çalışmıyordu.
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ['20', '50', '100', '200'],
            showTotal: (total) => `Toplam ${total} ders`,
          }}
          locale={{ emptyText: 'Bu aralıkta proje girilmemiş ders bulunamadı.' }}
        />
      </Card>
    </div>
  );
};

export default MissingProjectsReportTab;
